import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Hero, Pitch, Vision, Phases, Included, Pricing, Testimonials } from "@/lib/sections1";
import { Founder, ForHer, FAQ, FinalCTA, Footer } from "@/lib/sections2";

const LandingPage = () => (
  <main data-testid="landing-page" className="min-h-screen bg-cream font-body text-charcoal">
    <Hero />
    <Pitch />
    <Vision />
    <Phases />
    <Included />
    <Pricing />
    <Testimonials />
    <Founder />
    <ForHer />
    <FAQ />
    <FinalCTA />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
